import React, { useState, useEffect } from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import useHeaderGenerator from 'components/app/common/functions/useHeaderGenerator';
import FormModal from 'components/app/common/FormModal';
import AccountService from './AccountService';
import schema from './jsonSchema';
import Directory from 'components/dashboards/analytics/directory/Directory';
import DirectoryService from '../directory/DirectoryService';

const formatDate = inputDate => {
  const date = new Date(inputDate);
  const options = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  };

  const formattedDate = date.toLocaleDateString('en-US', options);
  return formattedDate;
};

const RootAccountDetails = () => {
  const { identifier } = useParams();
  const navigate = useNavigate();
  const [modalShow, setModalShow] = useState(false);
  const [account, setAccount] = useState();
  const [profiles, setProfiles] = useState([]);
  const showValue = attributeName => {
    return account && account[attributeName];
  };

  useEffect(() => {
    AccountService.retrieveAccount(identifier)
      .then(data => {
        setAccount(data);
      })
      .catch(error => {
        console.error('Error retrieving Account', error);
      });
      DirectoryService.retrieveProfilesByAccountIdentifier(identifier)
      .then(data => {
        setProfiles(data);
      })
      .catch(error => {
        console.error('Error retrieving profiles for Account', error);
      });
  }, []);

  const buttonsConf = [
    {
      name: 'Edit Account',
      type: 'button',
      variant: 'info',
      onClick: () => {
        console.log('Edit this event');
        navigate('/management-events/' + identifier + '/edit');
      }
    }
  ];

  const jsonSchema = schema;
  const headerGenerated = useHeaderGenerator('Account', ' ', buttonsConf);

  return (
    <>
      {headerGenerated}
      {modalShow && (
        <FormModal
          message={'Account has been updated!'}
          modalShow={modalShow}
          setModalShow={setModalShow}
        />
      )}
      {account && (
        <>
          <Card>
            <Card.Body>
              {jsonSchema.map(field => {
                if (field.type === 'group') {
                  return field.fields.map(f => (
                    <Row key={f.name}>
                      <Col xs={5} sm={4}>
                        <p className="fw-semi-bold mb-1">{f.label + ': '}</p>
                      </Col>
                      <Col>{showValue(f.name)}</Col>
                    </Row>
                  ));
                } else {
                  return (
                    <Row key={field.name}>
                      <Col xs={5} sm={4}>
                        <p className="fw-semi-bold mb-1">
                          {field.label + ': '}
                        </p>
                      </Col>
                      <Col>{showValue(field.name)}</Col>
                    </Row>
                  );
                }
              })}
            </Card.Body>
          </Card>
          {profiles && (
            <Card className="mt-3">
            <Card.Header>
              <h5>Associated Profiles</h5>
            </Card.Header>
            <Card.Body>
              {profiles.length > 0 ? (
                profiles.map(profile => (
                  <div key={profile.identifier}>{profile.email}</div>
                ))
              ) : (
                <p>No profiles associated with this account.</p>
              )}
            </Card.Body>
          </Card>)}
        </>
      )}
    </>
  );
};

export default RootAccountDetails;
